<template>
    <v-sheet class="sheetRangeCompo" :width="sheetWidth" :color="secundaryColor">
        <v-row class='ma-0'>
            <v-sheet :style="`color: ${colorTextPrinc};`" class="principalCardRange pt-1" :color="principalColor"> {{ principalText }}</v-sheet>
            <v-sheet :style="`color: ${colorTextSecun};`" class="secundaryCardRange pt-1"> {{ secundaryText }}</v-sheet>
        </v-row>
    </v-sheet>
</template>

<script setup lang="ts">
defineProps({
    principalText  : { type: String, required: true },
    secundaryText  : { type: String, required: true },
    principalColor : { type: String, required: true },
    secundaryColor : { type: String, required: true },
    colorTextPrinc : { type: String, required: true },
    colorTextSecun : { type: String, required: true },
    sheetWidth     : { type: Number, },
})
</script>
<style>
    .sheetRangeCompo{
        height: 25px;
        border-radius: 5px;
        text-align: center;
        align-content: center;
    }

    .principalCardRange{
        width: 50%;
        height: 25px;
        border-radius: 5px;
        align-content: center;
        font-size: 14px;
        font-weight: bold;
    }

    .secundaryCardRange{
        width: 50%;
        height: 25px;
        background-color: transparent;
        align-content: center;
        font-size: 12px;
    }
</style>